<template>
    <CCard class="page mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t("Headers") }}</h1>
                </CCol>
                <CCol class="d-flex justify-content-end">
                    <ButtonBack class="mr-3" title="Go back" />
                </CCol>
            </CRow>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer class="section" fluid>
                <CRow alignHorizontal="center"
                    v-show="
                    hasItemsInTable({
                        tableName: 'tagFields',
                    })
                "
                >
                    <CCol md="12">
                        <CCard>
                            <CCardHeader>
                                <CRow>
                                    <CCol>
                                        <h1 class="page__title">{{ $t("Fields") }}</h1>
                                    </CCol>
                                </CRow>
                            </CCardHeader>
                            <CCardBody>
                                <CRow class="border-bottom">
                                    <CCol >
                                        <CBreadcrumb class="background-full-white" :items="breadItems"/>
                                    </CCol>
                                </CRow>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.tagFields.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :itemsPerPageSelect="{
                                        values: [5, 10, 20],
                                    }"
                                    :columnFilterValue.sync="
                                        tables.tagFields.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.tagFields.rows"
                                    v-bind="tables.tagFields"
                                >
                                <template #details="{item}">
                                        <CCollapse :show="Boolean(item._toggled)">
                                            <CCardBody>
                                                <h4>
                                                    {{$t(item.name)}}
                                                </h4>
                                                <p class="text-muted">{{$t('type')}}: {{$t(item.type)}}</p>
                                                <!-- <p class="text-muted" v-if="item.subTagId">{{$t('sub_tag')}}: {{ getSubTagById(item.subTagId) ? getSubTagById(item.subTagId).name: ''  }}</p> -->
                                                <p class="text-muted">{{$t(item.name+'_description')}}</p>
                                                <p class="text-muted" v-if="item.options">{{$t('options')}}: {{item.options}}</p>
                                            </CCardBody>
                                        </CCollapse>
                                    </template>
                                     <template #options="{item, index}">
                                        <td class="py-2">
                                        <CButton
                                            color="primary"
                                            variant="outline"
                                            square
                                            size="sm"
                                            @click="toggleDetails('tagFields', index)"
                                        >
                                            {{Boolean(item._toggled) ? 'Hide' : 'Show'}}
                                        </CButton>
                                        </td>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.tagFields.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.tagFields.page"
                                        :pages="tables.tagFields.total_pages"
                                        align="center"
                                    />
                                    <CElementCover :opacity="0.8" class="bg-trasparent" v-if="tables.tagFields.loading"/>
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'tagFields'
                    })
                "
            >
                <template #title>
                    {{ 'Not fields found' }}
                </template>
                <template #description>
                    {{ $t("No fields have been found") }}
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'tagFields' 
                            })
                        "
                        @click="cleanFiltersAdvance('tagFields'), updateData()"
                    >
                        <span class="button__icon">
                            <CIcon
                                :content="$options.icons.eraser"
                            />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean filters") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import ButtonBack from "£lement/ButtonBack";
import ButtonLoading from "~/components/ButtonLoading.vue";
import NoItemsContainer from "~/components/NoItemsContainer";

/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table";
import traslateMixin from "~/mixins/traslate.js";
/** Icons */
import { eraser }  from '~/assets/icons/js/eraser';
/** Others */
import { 
    cilTrash,
    cilArrowBottom,
    cilArrowTop,
    cilPlus,
    cilPencil,
    cilCaretBottom,
    cilCaretTop,
    cilSave
} from "@coreui/icons";

export default {
    name: "Fields",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin, traslateMixin],
    components: {
        ButtonBack,
        ButtonLoading,
        NoItemsContainer
    },
    icons: {
        cilTrash,
        cilArrowTop,
        cilArrowBottom,
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilPlus,
        cilSave,
        eraser
    },
    
    data() {
        return {
            tables: {
                tagFields: {
                    items: [],
                    fields: [
                        {
                            label: "id",
                            key: "id",
                            sorter: false,
                            filter: false,
                            _style: 'width:10%',
                        },
                        {
                            label: "name",
                            key: "name",
                            sorter: false,
                            filter: true,
                            _style: 'width:40%',
                        },
                        {
                            label: "code",
                            key: "code",
                            sorter: false,
                            filter: true,
                            _style: 'width:40%',
                        },
                        {
                            key: 'options',
                            label: '',
                            _style: 'width:10%',
                            sorter: false,
                            filter: false,
                            fixed: true,
                        }
                    ],
                    order: "desc",
                    rows: 10,
                    page: 1,
                    total_pages: 0,
                    loading: true,
                    pagination: true,
                    sorter: true,
                    responsive: true,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                },
            },
            breadItems:[
                {
                    text: 'Tags',
                    to: '/app/documentation/headers'
                },
                {
                    text: ""
                }
            ]
        };
    },
    computed: {
        uuid: function () {
            return this.$route.query.uuid;
        }
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.tagFields.rows = newValue;
            this.updatePagination(this.tables.tagFields.page);
        },
        updatePagination(newValue) {
            this.tables.tagFields.page = newValue;
            this.updateData();
        },
        async getTagName(){
            let response = 
                await this.fetcher({
                    baseURL: process.env.VUE_APP_API_CORE,
                    url: `/tags/${this.uuid}`,
                    method: "GET",
                });
            this.breadItems[1].text= response._items.name;
            return response._items.name;
        },
        async updateData() {
            await this.updateTable({
                tableName: "tagFields",
                url: `/tags/${this.uuid}/fields`,
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
                adapterFilters: (filters)=>{
                    delete filters.where.created_at
                    return filters;
                }
            });
            
            this.tables.tagFields.loading = false;
            this.updatePageLoading(false);
        },
    },
    async mounted() {
        this.cleanFiltersAdvance('tagFields');
        await this.getTagName();
        await this.updateData();
    },
};
</script>

<style lang="scss" scoped>
.input-fields {
    margin-bottom: 1rem;
}
.background-full-white{
    background-color: #fff;
    border-color: #fff;
}
</style>
